const Tooltiptext = {
    // ----- Ticket -----
    TicketDescription: 'Short description of the task.',
    TicketAllocatedTo: 'Person you want to assign this ticket to.',
    TicketCheckedBy: 'Person who will verify if the work/task is completed',
    TicketObserver: 'Person who will verify if the work/task is completed',
    TicketRemarks: 'Any extra information that you want to mention in the ticket',
    TicketPredefinedTAT: 'Assign a TAT to this ticket.\n\nTAT (Turn Around Time) - \nTime required to complete this and only this task once.',
    TicketLocationOnAction: 'Get location of allocated to person when actions done on ticket.',
    TicketAlertNow: 'Alert the people associated in this ticket immediately.',
    TicketDueDate: 'Assign a due date to this task.',
    TicketAddStage: '',
    TicketActionTAT: 'Predicted TAT\n\nTAT (Turn Around Time) - \nTime required to complete this and only this task.',
    TicketOpenBeforeDays: 'Days before due date\n\nEg - If you want to open the critical ticket 2 days before due date, set value to 2.\n\nLeave field blank to enable default days.',

    // ----- Meeting -----
    MeetingName: 'Name of the meeting.',
    MeetingDescription: 'Description/Agenda of the meeting.',
    MeetingLocation: 'Meeting Location.',
    MeetingDuration: 'Predicted duration of the meeting.',
    MeetingDate: 'Scheduled meeting date.',
    MeetingGoogleMeet: 'Create a google meet link for the meeting.',
    MeetingTime: 'Scheduled meeting time.',
    MeetingPending: 'Scheduled meetings.',
    MeetingAttendees: 'Meeting attendees.',
    MeetingHost: 'Host of the meeting.',

    // ----- Activity -----
    ActivityDescription: 'Description of the activity.',
    ActivityTAT: 'TAT (Turn Around Time) - \nTime required to complete this and only this task once.',
    ActivityFrequency: 'Frequency at which this activity is repeated.',
    ActivityDueOn: 'Next due date of this activity.',
    ActivityCritical: '',
    ActivityOpenedBy: 'Ticket opened and checked by person.',

    // ----- Broadcast -----
    BroadcastMessage: 'Broadcast Message',
    BroadcastRecipients: 'People who can view this broadcast.',
    BroadcastVisibleDays: "Number of days the broadcast will be visible on recipient's home screen.",

    // ----- Organisation Setting -----
    OrganisationName: 'Name of the organisation.',
    OrganisationReportTime: 'Time at which Daily Work Reports should be notified.',
    OrganisationLocation: 'Locations of organisation.',

    // ----- Employee Configuration -----
    EmployeeConfigSalary: 'Monthly employee salary.',
    EmployeeConfigMaxOT: 'Maximum Overtime duration allowed.',
    EmployeeConfigOTRate: 'Hourly overtime rate.',

    // ----- Shift Master -----
    ShiftLateMarkRelaxation: 'Duration from shift start time after which employee will be marked late.',
    ShiftHalfMarkRelaxation: 'Duration from shift start time after which half day of the employee will be marked.',

    // ----- Add Expense -----
    ExpenseMadeBY:"Employee who made this Expense",
    ExpenseApprover:"Approver for this Expense",
    ExpenseType:"Type of Expense",
    ExpenseON:"Date when this Expense was made",
    AttachmentExpense:"Receipt/Bill for this Expense"
  };

  export default Tooltiptext;
